import React from "react";
import {
  CompanyRadarMetrics,
  CompanyRadarRole,
} from "reducers/companyProfileApi";
import MetricInfoTooltip, {
  MetricTooltipKey,
} from "components/MetricInfoTooltip";
import { ProfileCard, ProfileCardTitle } from "./ProfileCard";

interface CompanyMetricsProps {
  role: CompanyRadarRole;
  metrics?: CompanyRadarMetrics;
  isLoading: boolean;
  isError: boolean;
}

interface MetricItem {
  key: MetricTooltipKey;
  label: string;
  value: number | null | undefined;
}

const normalizeMetric = (value: number | null | undefined) =>
  Math.round(Math.min(100, Math.max(0, value ?? 0)));

const CompanyMetrics = ({
  role,
  metrics,
  isLoading,
  isError,
}: CompanyMetricsProps) => {
  const sellerValueItems: MetricItem[] =
    role === "seller"
      ? [
          {
            key: "value",
            label: "価値",
            value: metrics?.value,
          },
        ]
      : [];

  const items: MetricItem[] = [
    { key: "speed", label: "成約速度", value: metrics?.speed },
    {
      key: "reliability",
      label: "信頼性",
      value: metrics?.reliability,
    },
    { key: "stability", label: "継続力", value: metrics?.stability },
    ...sellerValueItems,
    {
      key: "circulation",
      label: "環境貢献",
      value: metrics?.circulation,
    },
  ];

  return (
    <ProfileCard className="min-h-[472px]">
      <ProfileCardTitle>能力チャート</ProfileCardTitle>
      <div className="mt-[30px] flex flex-col gap-[20px]">
        {isLoading && (
          <div className="flex min-h-[300px] items-center justify-center font-bold text-white">
            読み込み中...
          </div>
        )}
        {isError && !isLoading && (
          <div className="flex min-h-[300px] items-center justify-center font-bold text-white">
            データを取得できませんでした
          </div>
        )}
        {!isLoading &&
          !isError &&
          items.map((item) => {
            const value = normalizeMetric(item.value);

            return (
              <div key={item.key}>
                <div className="flex items-end justify-between">
                  <span className="flex items-center gap-[5px] text-[14px] font-bold leading-[1.6] text-white">
                    <span>{item.label}</span>
                    <MetricInfoTooltip
                      metricKey={item.key}
                      label={item.label}
                      className="text-white/85"
                    />
                  </span>
                  <span className="flex items-end text-right">
                    <span className="font-['Audiowide'] text-[26px] leading-[1.1] text-[#d4f754]">
                      {value}
                    </span>
                    <span className="mb-[1px] ml-[2px] text-[12px] font-bold text-white">
                      %
                    </span>
                  </span>
                </div>
                <div className="mt-[5px] h-[16px] overflow-hidden rounded-[8px] bg-[#002959]">
                  <div
                    className="h-full bg-[linear-gradient(90deg,#d4f754_0%,#2cdcec_100%)]"
                    style={{ width: `${value}%` }}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </ProfileCard>
  );
};

export default CompanyMetrics;
